import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Table } from 'antd'
import styles from '../../styles/sales.module.scss'

const ProductPriceComponent = ({
  sellerList,
  orderInfo,
  setOrderInfo,
  selectedOptionRows,
  setSelectedOptionRows,
  selectedOptionRowKeys,
  setSelectedOptionRowKeys,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [selectSeller, setSelectSeller] = useState([])
  const [productBySeller, setProductBySeller] = useState([])
  const [deliveryBySeller, setDeliveryBySeller] = useState([])

  const columns = [
    {
      title: '브랜드명',
      width: 100,
      dataIndex: 'brandName',
      key: 'brandName',
      ellipsis: true,
    },
    {
      title: '상품명',
      width: 150,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      width: 150,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
      render: (value) => (
        <p
          style={{
            width: '150px',
            fontSize: '1em',
            margin: 0,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {value}
        </p>
      ),
    },
    {
      title: '가격',
      width: 150,
      dataIndex: 'price2',
      key: 'price2',
      ellipsis: true,
      render: (value, record) => (value * record?.quantity)?.toLocaleString(),
    },
    {
      title: '수량',
      width: 150,
      // dataIndex: 'option_benefit',
      // key: 'option_benefit',
      ellipsis: true,
      fixed: 'right',
      align: 'center',
      render: (value, record, index) => {
        return (
          <div>
            <Button
              id="minus"
              onClick={(e) => changeProductQuantity(e, 'minus', value, index)}
              size={`small`}
            >
              -
            </Button>
            <Button size={`small`}>
              {value.quantity ? value.quantity : 1}
            </Button>
            <Button
              id="plus"
              onClick={(e) => changeProductQuantity(e, 'plus', value, index)}
              size={`small`}
            >
              +
            </Button>
          </div>
        )
      },
    },
    {
      title: '삭제',
      key: 'operation',
      width: 100,
      fixed: 'right',
      align: 'center',
      render: (value, record, index) => (
        <img
          src={`${process.env.REACT_APP_HOST}/assets/icon/sales/delete-dark-gray-circle.png`}
          // className={`delete-button`}
          alt={'닫기 버튼'}
          onClick={() => deleteCartOption(value, record, index)}
          style={{
            width: '1.2em',
            height: '1.2em',
          }}
        />
      ),
    },
  ]

  /**
   * 구매할 옵션 삭제하기
   * @param value
   * @param record
   * @param index
   */
  const deleteCartOption = (value, record, index) => {
    let list = [...selectedOptionRows]
    let keyList = [...selectedOptionRowKeys]
    list.splice(index, 1)
    keyList.splice(index, 1)
    setSelectedOptionRows(list)
    setSelectedOptionRowKeys(keyList)
  }

  /**
   * 주문 결제 상품 - 수량 변경
   */
  const changeProductQuantity = (e, method, value, index) => {
    e.stopPropagation()
    let currList = [...selectedOptionRows]
    let target = { ...value }
    if (method === 'plus') {
      target.quantity += 1
    } else {
      if (target?.quantity > 1) {
        target.quantity -= 1
      }
    }
    currList[index] = target
    setSelectedOptionRows(currList)
  }

  useEffect(() => {
    if (selectedOptionRows?.length) {
      let priceList = selectedOptionRows.map(
        (item) => item.price2 * item.quantity,
      )
      let totalPrice = priceList.reduce((a, b) => a + b, 0)
      setOrderInfo({
        ...orderInfo,
        totalPrice: totalPrice,
      })

      let sellers = selectedOptionRows.map((item) => ({
        ...sellerList.filter(
          (seller) => item.sellerId === seller.sellerId,
        )?.[0],
      }))
      setSelectSeller(sellers)
    } else {
      setOrderInfo({
        ...orderInfo,
        totalPrice: 0,
      })
      setSelectSeller([])
    }
  }, [selectedOptionRows])

  useEffect(() => {
    let list = []
    for (let i = 0; i < selectSeller?.length; i++) {
      let obj = {
        sellerId: null,
        sellerName: null,
        selectList: [],
      }
      // 판매자 별로 다시 묶기
      let filter = selectedOptionRows.filter(
        (item) => item.sellerId === selectSeller[i].sellerId,
      )
      obj.sellerId = selectSeller[i].sellerId
      obj.sellerName = selectSeller[i].sellerName
      obj.deliveryPrice = selectSeller[i].deliveryPrice
      obj.deliveryPriceBaseline = selectSeller[i].deliveryPriceBaseline
      obj.selectList = filter
      list.push(obj)
    }
    // 판매자 중복 제거
    if (list?.length) {
      const filteredList = list.reduce((prev, curr) => {
        const findData = prev.find((item) => item.sellerId === curr.sellerId)
        if (!findData) {
          return prev.concat([curr])
        } else {
          return prev
        }
      }, [])
      setProductBySeller(filteredList)
    } else {
      setProductBySeller([])
    }
  }, [selectSeller])

  useEffect(() => {
    if (productBySeller?.length) {
      let list = []
      for (let i = 0; i < productBySeller?.length; i++) {
        let obj = {}
        let selectList = productBySeller[i]?.selectList
        let totalPrice = 0
        for (const item of selectList) {
          totalPrice += item.price2 * item.quantity
        }

        obj.sellerId = productBySeller[i].sellerId
        obj.sellerName = productBySeller[i].sellerName
        obj.deliveryPriceBaseline = productBySeller[i].deliveryPriceBaseline
        obj.totalPrice = totalPrice
        if (totalPrice >= productBySeller[i].deliveryPriceBaseline) {
          obj.deliveryPrice = 0
        } else {
          obj.deliveryPrice = productBySeller[i].deliveryPrice
        }

        list.push(obj)
      }
      setDeliveryBySeller(list)
    } else {
      setDeliveryBySeller([])
    }
  }, [productBySeller])

  useEffect(() => {
    setOrderInfo({
      ...orderInfo,
      deliveryPrice: deliveryBySeller
        ?.map((d) => d.deliveryPrice)
        ?.reduce((a, b) => a + b, 0),
    })
  }, [deliveryBySeller])

  return (
    <>
      <div
        className={`${styles['order-component-each-detail']}`}
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '10px',
        }}
      >
        <h4 className={`${styles['order-each-detail-title']}`}>장바구니</h4>
        <Table
          className={`${styles['order-create-product-list-table']} ${styles['order-create-product-option-list-table']}`}
          columns={columns}
          dataSource={selectedOptionRows}
          loading={isLoading}
          bordered
          size="middle"
          rowKey="id"
          rowClassName="coupon-table-row"
          scroll={{ x: true }}
          pagination={false}
        />
      </div>
      {/* 배송비 */}
      <div className={`${styles['order-component-each']}`}>
        <h3 className={`${styles['order-each-title']}`}>
          배송비
          <span className={`${styles['title-required']}`}>*</span>
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '3px' }}
            >
              <Col>
                <div
                  className={`${styles['delivery-price-div']}`}
                  style={{
                    flexDirection: 'column',
                    marginBottom: '5px',
                  }}
                >
                  {deliveryBySeller?.map((item, idx) => (
                    <div
                      key={`delivery-by-seller-${idx}`}
                      style={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center',
                      }}
                    >
                      <p style={{ color: '#adb5bd', fontSize: '0.8rem' }}>
                        {item?.sellerName} :
                      </p>
                      <p>{item?.deliveryPrice?.toLocaleString()}원</p>
                      {!!item?.deliveryPrice && (
                        <p style={{ color: '#adb5bd', fontSize: '0.8rem' }}>
                          ({item?.deliveryPriceBaseline?.toLocaleString()}원
                          이상 구매 시 무료배송)
                        </p>
                      )}
                    </div>
                  ))}
                  <p
                    style={{
                      fontSize: '1em',
                      fontWeight: 600,
                    }}
                  >
                    총 배송비 :{' '}
                    {deliveryBySeller
                      ?.map((d) => d.deliveryPrice)
                      ?.reduce((a, b) => a + b, 0)
                      ?.toLocaleString()}
                    원
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>

      {/* 총 금액 */}
      <div className={`${styles['order-component-each']}`}>
        <h3 className={`${styles['order-each-title']}`}>
          총 금액
          <span className={`${styles['title-required']}`}>*</span>
        </h3>
        <Col className={`${styles['order-component-each-col']}`}>
          <div className={`${styles['order-component-each-detail']}`}>
            <Row
              align="top"
              justify={'space-between'}
              style={{ rowGap: '3px' }}
            >
              <Col>
                <div
                  className={`${styles['delivery-price-div']}`}
                  style={{
                    alignItems: 'center',
                  }}
                >
                  <p>
                    <b>
                      {(
                        orderInfo?.totalPrice + orderInfo?.deliveryPrice
                      )?.toLocaleString()}
                      원
                    </b>
                  </p>
                  <p
                    style={{
                      fontSize: '1em',
                    }}
                  >
                    ({orderInfo?.totalPrice?.toLocaleString()}원 +{' '}
                    {orderInfo?.deliveryPrice?.toLocaleString()}원)
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>
    </>
  )
}
export default ProductPriceComponent
